import { render, staticRenderFns } from "./DynamicXq.vue?vue&type=template&id=642840bd&scoped=true"
import script from "./DynamicXq.vue?vue&type=script&lang=js"
export * from "./DynamicXq.vue?vue&type=script&lang=js"
import style0 from "./DynamicXq.vue?vue&type=style&index=0&id=642840bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642840bd",
  null
  
)

export default component.exports